import { GREECE_NOMOI } from '@/lib/greeceNomoiMap';

// Προσεγγιστική γειτνίαση νομών, υπολογισμένη από το κεντροειδές κάθε νομού
// (μέσος όρος όλων των κορυφών του polygon). Δεν είναι τοπολογικά ακριβής
// (δεν ξέρει αν δύο νομοί μοιράζονται πραγματικά σύνορο), αλλά αρκεί για ένα
// "sonar scan" που διευρύνει σταδιακά προς τους πλησιέστερους νομούς.
function centroid(shapes: string[]): [number, number] {
  let sx = 0, sy = 0, n = 0;
  for (const shape of shapes) {
    for (const pair of shape.trim().split(/\s+/)) {
      const [x, y] = pair.split(',').map(Number);
      sx += x; sy += y; n++;
    }
  }
  return [sx / n, sy / n];
}

const CENTROIDS: Record<string, [number, number]> = {};
for (const { region, shapes } of GREECE_NOMOI) CENTROIDS[region] = centroid(shapes);

const ALL_REGIONS = GREECE_NOMOI.map((n) => n.region);

/** Οι `count` πλησιέστεροι νομοί σε έναν δοσμένο νομό, ταξινομημένοι από τον κοντινότερο. */
export function getNearestRegions(region: string, count = 8): string[] {
  const origin = CENTROIDS[region];
  if (!origin) return [];
  return ALL_REGIONS
    .filter((r) => r !== region)
    .map((r) => {
      const [x, y] = CENTROIDS[r];
      const d = Math.hypot(x - origin[0], y - origin[1]);
      return { r, d };
    })
    .sort((a, b) => a.d - b.d)
    .slice(0, count)
    .map((e) => e.r);
}
